import type { BaseEditor } from "slate";
import { Editor } from "slate";
import type { HistoryEditor } from "slate-history";
import type { ReactEditor, RenderElementProps } from "slate-react";

export interface ICustomElement {
  type: string;
  children: any[];
  align?: string;
  depth?: number;
  url?: string;
}

interface CustomMethods {
  insertLink: (editor: BaseEditor, url: string) => void;
}

export enum NodeTypes {
  PARAGRAPH = "paragraph",
  ORDERED_LIST = "ordered-list",
  UNORDERED_LIST = "unordered-list",
  LIST_ITEM = "list-item",
  LIST_ITEM_TEXT = "list-item-text",
  HEADING = "heading",
  BLOCK_QUOTE = "blockquote",
  BLOCK_CODE = "code",
  CODE_LINE = "code-line",
  LINK = "link",
  THEMATIC_BREAK = "thematicBreak",
}

export enum LeafTypes {
  BOLD = "strong",
  ITALIC = "emphasis",
}
export type SlateRenderElementProps = RenderElementProps;

declare module "slate" {
  interface CustomTypes {
    Editor: BaseEditor & ReactEditor & HistoryEditor & CustomMethods;
    Element: ICustomElement;
    Ancestor: any;
  }
}
